import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import BakingPage from "./pages/BakingPage";
import RecipeDetailPage from "./pages/RecipeDetailPage";
import DevBlogPage from "./pages/DevBlogPage";
import PostDetailPage from "./pages/PostDetailPage";
import DevHacksPage from "./pages/DevHacksPage";
import AboutPage from "./pages/AboutPage";
import ResumePage from "./pages/ResumePage";
import "./styles/global.css";
import PWABadge from "./components/PWABadge";

export default function App() {
  return (
    <BrowserRouter>
      <div className="app-root">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/baking" element={<BakingPage />} />
            <Route path="/baking/:slug" element={<RecipeDetailPage />} />
            <Route path="/dev" element={<DevBlogPage />} />
            <Route path="/dev/:slug" element={<PostDetailPage />} />
            <Route path="/hacks" element={<DevHacksPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/resume" element={<ResumePage />} />
          </Routes>
        </main>
        <Footer />
        <PWABadge />
      </div>
    </BrowserRouter>
  );
}
